import { render, staticRenderFns } from "./PartnerSelect.vue?vue&type=template&id=38589738"
import script from "./PartnerSelect.vue?vue&type=script&lang=js"
export * from "./PartnerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports